import { useMemo } from 'react';
import classes from 'components/widgets/ProjectSummary/cardWrapper.module.scss';
import { WidgetCard } from 'components/common';
import { maxBy, orderBy } from 'lodash';
import { getColorByStatus } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramStatusSummaryReport/programStatusSummaryReport.utils';
import { RiskCardMetrics } from 'components/widgets/ProjectSummary/RiskCard/RiskCardMetrics';
import { ToggleCollapse } from 'components/widgets/ProjectSummary/ToggleCollapse';
import { maxHeight, maxValueScale } from 'components/widgets/ProjectSummary/cardsSection.utils';
import { NoApplicableData } from 'components/widgets/ProjectSummary/noApplicableData';
import { useThemeStatusStore } from 'store/themeStatus.store';
import { SummaryCard } from 'api/queries/getProjectStatusScoreCards.query';
import { RiskCardGraph } from 'components/widgets/ProjectSummary/RiskCard/RiskCardGraph';

interface Props extends SummaryCard {
    collapse: boolean;
    setCollapse: (value: boolean) => void;
}

export const RiskCard = ({ cardProperties, cardTitle, cardTrends, collapse, setCollapse, overallScore }: Props) => {
    const sortedMetricsList = useMemo(() => orderBy(cardProperties.metrics, ['order', 'desc']), [cardProperties]);
    const showGraphSection = cardTrends?.[0];
    const height = !collapse && showGraphSection ? maxHeight : '100%';
    const maxValuePoint = maxBy(cardTrends?.[0]?.graphPoints, 'score');
    const maxValue = maxValuePoint ? maxValuePoint?.score * maxValueScale : undefined;
    const status = cardTitle.status;
    const tooltipContent =
        status === 'N/A' ? 'Not applicable with applied filter' : `Overall Score is ${overallScore.value}`;
    const id = `statusSummary_risk`;

    const { themeStatus } = useThemeStatusStore();

    return (
        <WidgetCard
            titleColor={getColorByStatus({ status, theme: themeStatus })}
            titleText={cardTitle.title}
            scoreValue={status}
            contentHeight={height}
            tooltipContent={tooltipContent}
            id={id}
        >
            {status === 'N/A' && <NoApplicableData id={id} />}
            {status !== 'N/A' && (
                <div className={classes.cardWrapper}>
                    <div className={classes.topSection}>
                        <div className={`${classes.metricsListContainer} ${collapse && classes.collapse}`}>
                            <RiskCardMetrics sortedMetricsList={sortedMetricsList} id={id} />
                        </div>
                        <ToggleCollapse setCollapse={setCollapse} collapse={collapse} id={id} />
                    </div>
                    {showGraphSection && (
                        <RiskCardGraph
                            data={cardTrends}
                            xaxisTitle={'Version'}
                            yaxisTitle={'Risk'}
                            yAxisMaxValue={maxValue}
                        />
                    )}
                </div>
            )}
        </WidgetCard>
    );
};
